var exports = {
  "k": "EmbedAudio.module__container___aFQtcW",
  "G": "EmbedAudio.module__deleteButton___aFQtcW",
};

module.exports = exports;
